import {
  CART_OFFER_COMPARISON_ADD_SELECTION,
  CART_OFFER_COMPARISON_REMOVE_SELECTION,
  CART_OFFER_COMPARISON_REPLACE_SELECTION,
  CART_OFFER_COMPARISON_CLEAR_ALL,
  API_CALL,
} from './actionConstants'
import {
  FETCH_CART_OFFER_COMPARISON_ITEMS,
  CREATE_CART_OFFER_COMPARISON_ITEM,
} from './apiActionConstants'
import * as cartOfferComparisonAPI from 'api/cartOfferComparison'
import type { AppAction } from './types/ActionTypes'
import { nonNullable } from 'lib/array/arrayUtils'
import uuidV4 from 'lib/string/uuidV4Utils'
import config from 'constants/config'
import { slimifyGeo } from 'lib/geo/geoUtils'
import { getUtmParams } from 'storage/checkout'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { getOfferComparisonSelectionPrice } from 'lib/offerComparison/getOfferComparisonSelectionTotal'
import type { CartItem } from 'api/cart/putCheckoutCart'
import { putCheckoutCart } from 'api/cart/putCheckoutCart'
import { createQuoteFromCart } from 'api/cart/createQuoteFromCart'

export function addCartOfferComparisonSelection(selection: App.OfferComparisonSelection): AppAction {
  return {
    type: CART_OFFER_COMPARISON_ADD_SELECTION,
    selection,
  }
}

export function removeCartOfferComparisonSelection(selectionId: string): AppAction {
  return {
    type: CART_OFFER_COMPARISON_REMOVE_SELECTION,
    selectionId,
  }
}

export function replaceCartOfferComparisonSelection(selection: App.OfferComparisonSelection): AppAction {
  return {
    type: CART_OFFER_COMPARISON_REPLACE_SELECTION,
    selection,
  }
}

export function clearAllCartOfferComparisonSelections(): AppAction {
  return {
    type: CART_OFFER_COMPARISON_CLEAR_ALL,
  }
}

export function fetchCartOfferComparisonItems(): AppAction {
  return {
    type: API_CALL,
    api: FETCH_CART_OFFER_COMPARISON_ITEMS,
    request: () => cartOfferComparisonAPI.getActiveComparisonItems(),
  }
}

export function createCartOfferComparison(): AppAction {
  return (dispatch, getState) => {
    const state: App.State = getState()

    const spoofedSelections = state.cartOfferComparison.spoofedSelections

    if (!spoofedSelections.length) {
      return
    }

    const canRedeemLuxPlus = getCanRedeemLuxPlusBenefits(state)
    const items = nonNullable(spoofedSelections.map(selection => ({
      offerType: selection.offerType,
      total: getOfferComparisonSelectionPrice(selection, canRedeemLuxPlus),
    }))) as Array<CartItem>

    dispatch({
      type: API_CALL,
      api: CREATE_CART_OFFER_COMPARISON_ITEM,
      request: async() => {
        // Create a separate quote for each comparison item so they can be easily restored individually
        await Promise.all(items.map(async item => {
          const cartForQuoteId = uuidV4()
          await putCheckoutCart(cartForQuoteId, {
            brand: config.BRAND,
            geo: slimifyGeo(state.geo),
            items: [item],
            utm_params: getUtmParams(state.utm),
            total: Number((item as any).total ?? 0),
          })
          await createQuoteFromCart(cartForQuoteId, undefined, state.utm.medium ? [state.utm.medium] : undefined)
        }))
        return cartOfferComparisonAPI.createCartOfferComparison(spoofedSelections)
      },
    })
  }
}
